const appIntervals = []

export function registerInverval (interval) {
  if (appIntervals.indexOf(interval) < 0) {
    appIntervals.push(interval)
  }
}

export function destroyInverval (interval) {
  clearInterval(interval)
}

export function clearAllInterval () {
  appIntervals.forEach(interval => clearInterval(interval))
}



// WEBPACK FOOTER //
// ./src/utilities/global.interval.js